/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiLibraryScenario } from './InternalApiLibraryScenario';
import {
    InternalApiLibraryScenarioFromJSON,
    InternalApiLibraryScenarioFromJSONTyped,
    InternalApiLibraryScenarioToJSON,
    InternalApiLibraryScenarioToJSONTyped,
} from './InternalApiLibraryScenario';

/**
 * 
 * @export
 * @interface InternalApiLibraryScenarioPage
 */
export interface InternalApiLibraryScenarioPage {
    /**
     * 
     * @type {number}
     * @memberof InternalApiLibraryScenarioPage
     */
    number: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiLibraryScenarioPage
     */
    size: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiLibraryScenarioPage
     */
    total: number;
    /**
     * 
     * @type {Array<InternalApiLibraryScenario>}
     * @memberof InternalApiLibraryScenarioPage
     */
    content: Array<InternalApiLibraryScenario>;
}

/**
 * Check if a given object implements the InternalApiLibraryScenarioPage interface.
 */
export function instanceOfInternalApiLibraryScenarioPage(value: object): value is InternalApiLibraryScenarioPage {
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function InternalApiLibraryScenarioPageFromJSON(json: any): InternalApiLibraryScenarioPage {
    return InternalApiLibraryScenarioPageFromJSONTyped(json, false);
}

export function InternalApiLibraryScenarioPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiLibraryScenarioPage {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'],
        'size': json['size'],
        'total': json['total'],
        'content': ((json['content'] as Array<any>).map(InternalApiLibraryScenarioFromJSON)),
    };
}

export function InternalApiLibraryScenarioPageToJSON(json: any): InternalApiLibraryScenarioPage {
    return InternalApiLibraryScenarioPageToJSONTyped(json, false);
}

export function InternalApiLibraryScenarioPageToJSONTyped(value?: InternalApiLibraryScenarioPage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'number': value['number'],
        'size': value['size'],
        'total': value['total'],
        'content': ((value['content'] as Array<any>).map(InternalApiLibraryScenarioToJSON)),
    };
}

